<template>
  <div class="export-data">
    <div class="common-title-page export-pod-data">
      <div class="page-title">POD DATA STREAM</div>
      <div class="page-content max-wp-100">
        <div class="stream-toolbar">
          <span class="stream-title">{{ $t('text.raw_data') }}</span>
          <el-input
            v-model="filter"
            size="small"
            prefix-icon="el-icon-search"
            placeholder="mac address / node mac"
            class="stream-filter"
            clearable
          ></el-input>
          <el-checkbox v-model="autoRefresh">{{
            $t('text.auto_refresh')
          }}</el-checkbox>
        </div>
        <ul class="raw-data-wrapper">
          <li v-for="(item, index) in rawData" :key="index">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/ApiService.js'
export default {
  data() {
    return {
      autoRefresh: true,
      loading: false,
      rawData: [],
      timer: '',
      filter: '',
      filterTimer: ''
    }
  },
  watch: {
    filter() {
      if (this.filterTimer) {
        clearTimeout(this.filterTimer)
      }
      this.filterTimer = setTimeout(this.getData, 500)
    },
    autoRefresh() {
      if (!this.autoRefresh) {
        clearInterval(this.timer)
      } else {
        this.timer = setInterval(this.getData, 2000)
      }
    }
  },
  mounted: function() {
    this.getData()
    this.timer = setInterval(this.getData, 2000)
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.LatestRecords()
        .then(response => {
          this.loading = false
          this.rawData = []
          let vm = this
          response.data.forEach(item => {
            if (item && item.length) {
              item.forEach(subItem => {
                vm.rawData.push(subItem)
              })
            }
          })
          if (this.filter) {
            this.rawData = this.rawData.filter(
              item =>
                (item.mac &&
                  item.mac.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                    -1) ||
                (item.podId &&
                  item.podId.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                    -1) ||
                (item.nodeMac &&
                  item.nodeMac.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                    -1) ||
                (item.NodeMac &&
                  item.NodeMac.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                    -1)
            )
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.stream-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.stream-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.stream-filter {
  width: 260px;
}
</style>
